import { isNil } from 'lodash-es';
import { useContext } from 'react';

import { ModulesContext } from './ModulesProvider';

const useModules = () => {
  const ctx = useContext(ModulesContext);

  if (isNil(ctx)) {
    throw new Error('useModules must be used within a ModulesProvider!');
  }

  return ctx;
};

export default useModules;
